<div id="navigation">
  <div class="logos">
    <div class="logo-container">

      <div id="logo">
        <a [routerLink]="['/']">
          <img src="./assets/logo.webp" height="55" alt="ExpertTabla.ro Logo" />
        </a>
      </div>

      <div id="bilkaLogo">
        <a [routerLink]="['/']">
          <img src="./assets/bilka-logo.svg" alt="Bilka logo" itemprop="logo" height="40">
        </a>
      </div>
      <div id="wetterbestLogo">
        <a [routerLink]="['/']">
          <img src="./assets/logo-wetterbest-big.webp" alt="Wetterbest logo" itemprop="logo" height="55">
        </a>
      </div>
    </div>
    <div id="topNav">
      <rc-products-menu></rc-products-menu>
      <a mat-flat-button href="https://experttabla.ro/contact/">Contact</a>
    </div>
    <div class="user-menu" *ngIf="user">
      <button mat-button [matMenuTriggerFor]="menu">
        {{ user.name }}
        <span class="material-icons">arrow_drop_down</span>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="logout()">Logout</button>
      </mat-menu>
    </div>


  </div>
  <div id="secondRow">
    <button mat-button class="hamburger-menu" (click)="onMenuClick()">
      <mat-icon>menu</mat-icon>
    </button>
    <button mat-button [routerLink]="['/cos']">
      <mat-icon>shopping_cart</mat-icon>
      {{
        cart && cart.calculations && cart.calculations.length
          ? cart.calculations.length + ' proiect' + ((cart.calculations.length || 0) > 1 ? 'e' : '')
          : 'Coșul meu'
      }}
    </button>

  </div>
  <div class="nav-border"></div>
  <div class="left-menu" id="button-menu">
    <a *ngFor="let calculationType of calculationTypes" mat-flat-button [routerLink]="calculationType.link" [routerLinkActive]="'active'"
       (click)="handleResetStep()">
      <img [src]="calculationType.imgLink">
      {{ calculationType.topNavTitle || calculationType.title }}
    </a>
  </div>
</div>
